import CaracteristiqueAccordionHeadingController from './caracteristique.accordion.heading.controller';
import Template from './caracteristique.accordion.heading.html';

export default {
	template: Template,
	controller: CaracteristiqueAccordionHeadingController,
	bindings: {
		accordeonLibelle: '<',
		idType: '<',
		caracteristiquesCount: '<',
		caracteristiquesRenseigneesCount: '<'
	}
};
